<template>
    <div>
        <action-bar>
            <router-link to="/online-factor-factor-create" class="btn btn-success">{{ 'ایجاد فاکتور' }}</router-link>
        </action-bar>
        <online-factor-filter :action="filterAction"></online-factor-filter>
        <factor-with-manage v-if="$can('read', 'payment-link')" :query="query" ref="datatable"/>
        <factor-without-manage v-else :query="query" ref="datatable" />
    </div>
</template>

<script>
import Filter from './components/filter_factor.vue';
import actionBar from '@/components/custom/action-bar';
import FactorsWithManageAccess from './FactorsWithManageAccess.vue';
import FactorsWithoutManageAccess from './FactorsWithoutManageAccess.vue';


export default {
    name: 'factors',
    components: {
        'online-factor-filter': Filter,
        'action-bar': actionBar,
        'factor-with-manage': FactorsWithManageAccess,
        'factor-without-manage': FactorsWithoutManageAccess
        
    },
    data() {
        return {
            query: {}
        };
    },
    methods: {
        filterAction(e, query) {
            this.query = query;
            if (this.$refs.datatable && this.$refs.datatable.$refs.datatable) {
                this.$refs.datatable.$refs.datatable.reload();
            }
        }
    }
};
</script>
